module.exports = __webpack_public_path__ + "static/media/tree-minus.ad2f64bb.svg";